<template>
  <el-image
    fit="cover"
    :src="src"
    :preview-src-list="list"
    style="border-radius: 6px"
  >
    <div slot="error" class="image-slot">
      <i class="el-icon-picture-outline"></i>
    </div>
  </el-image>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style></style>
